import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * Standalone icon, called by selector instead of hand-writing `<i>` tags:
 *
 *   <app-icon icon="fas fa-chair"></app-icon>
 *   <app-icon icon="far fa-calendar mr-1"></app-icon>
 *
 * `icon` is the full FontAwesome class string, optionally with GLOBAL utility
 * classes (margins, `fs-*`, `text-*`, …). The host uses `display: contents`,
 * so the rendered `<i>` participates in the parent layout exactly like a raw
 * tag — margins, inline flow, and flex gaps behave identically.
 *
 * Screen-scoped classes (defined in a component's own SCSS) do NOT work here:
 * emulated encapsulation cannot reach the inner `<i>`. Icons needing such a
 * class stay as raw `<i>` tags, or the class moves to a global stylesheet.
 * Icons INSIDE app-button use its startIcon/endIcon inputs, not this.
 */
@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [NgClass],
  template: `<i [ngClass]="icon"></i>`,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class IconComponent {
  /** Full icon class string, e.g. 'fas fa-chair' or 'far fa-copy mr-1'. */
  @Input() icon = '';
}
